import { render } from "./OnboardWrapper.vue?vue&type=template&id=53192e6f&scoped=true&ts=true&lang=pug"
import script from "./OnboardWrapper.vue?vue&type=script&lang=ts"
export * from "./OnboardWrapper.vue?vue&type=script&lang=ts"

import "./OnboardWrapper.vue?vue&type=style&index=0&id=53192e6f&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./OnboardWrapper.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/onboarding/onboarding.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2Fonboarding%2FOnboardWrapper.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53192e6f"]])

export default __exports__